<template>
  <div class="companyNews" id="companyNews">
    <my-header />

    <!-- 标题公司动态 -->
    <div class="pre">
      <div class="allTitle">
        <span>公司动态</span>
      </div>
    </div>
    <div
      v-for="(currect, i) in dataList"
      :class="{
        companyDivLast: i == dataList.length - 1,
        companyDiv: i != dataList.length - 1
      }"
    >
      <!-- 图片1 -->
      <div class="newImg">
        <img :src="currect.imgPath" />
      </div>

      <div class="invite" v-html="currect.content"></div>
    </div>

    <my-footer />
  </div>
</template>

<style>
/*最外层 */
.pre {
  width: 100%;
}

.companyNews .pre .allTitle {
  width: 90%;
  text-align: center;
  margin: 0 auto;
  color: #8d8c8c;
  font-size: 53px;
  padding-top: 40px;
  letter-spacing: 10px;
  padding-left: 10px;
  font-weight: lighter;
}

.companyDiv {
  border-bottom: 1px solid #c4c4c4;
}

.companyDivLast {
  border-bottom: 0;
}

.newImg img {
  width: 100%;
  padding-top: 40px;
}

.invite {
  width: 100%;
  text-align: center;
  font-size: 25px;
  color: #595757;
  margin-top: 40px;
  padding-bottom: 50px;
}

/* .inviteLast {
		width: 100%;
		text-align: center;
		font-size: 25px;
		color: #595757;
		margin-top: 40px;
		padding-bottom: 50px;
		border-bottom: 0;
	} */

.invite p {
  width: 90%;
  margin: 0 auto;
  padding-top: 10px;
  letter-spacing: 2px;
}
</style>

<script>
import myHeader from "@/views/myHeader.vue";
import myFooter from "@/views/myFooter.vue";

export default {
  components: {
    myHeader,
    myFooter
  },
  data() {
    return {
      dataList: []
    };
  },
  mounted() {
    if (this.$route.query.go) {
      document.querySelector("#" + this.$route.query.go).scrollIntoView(true);
    }

    let that = this;
    that.$axios
      .get(that.$global.baseURL + "/web/newsList/getNewsListByCatalogId.form", {
        params: {
          catalogId: "2"
        }
      })
      .then(res => {
        if (res.data.jsonArray == "error") {
          uni.showModal({
            title: res.data.errorInfo,
            showCancel: false
          });
        } else {
          that.dataList = res.data.dataList;
        }
      });
  }
};
</script>
